// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const row = "CategoriesListMobile__row__njGI8";
export const shaded = "CategoriesListMobile__shaded__QyuDr";
export const totalRow = "CategoriesListMobile__totalRow__ECuZD";
export const rowLabel = "CategoriesListMobile__rowLabel__SPM0u font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const items = "CategoriesListMobile__items__ZJhjc";
export const item = "CategoriesListMobile__item__Zlb3f";
export const member = "CategoriesListMobile__member__6pI06";
export const peers = "CategoriesListMobile__peers__2Gi0v";
export const others = "CategoriesListMobile__others__gwvZA";